import { createFileRoute, redirect } from '@tanstack/react-router';

// The Privacy Policy now lives as a section of the consolidated /legal page.
// Keep this URL working for old links and bookmarks by redirecting to it.
export const Route = createFileRoute('/privacy')({
  beforeLoad: () => {
    throw redirect({ to: '/legal', hash: 'privacy' });
  },
});
